/**
 * When applied, these run before any ZOD validation happens.
 */

/**
 * Filters unresolved entries in a multiple relationship from a Contentful response.
 *
 * @param value
 */
export function filterUnresolvedLinks<T>(value: unknown): T[] {
  if (!Array.isArray(value)) return [];
  return value.filter((item: any) => {
    return item && item.fields && item.sys?.type === 'Entry';
  });
}

/**
 * Filters unresolved entries in a singular relationship from a Contentful response.
 *
 * @param value
 */
export function filterUnresolvedLink(value: unknown): unknown {
  if (!value || typeof value !== 'object') return null;
  const item = value as any;
  // If it's an unresolved link (no fields), return null
  if (!item.fields && item.sys?.type === 'Link') return null;
  // If it's resolved or already null/undefined, return as-is
  return item.fields && item.sys?.type === 'Entry' ? value : null;
}
